import { render, staticRenderFns } from "./userInfo_individualHome.vue?vue&type=template&id=e52c8264&scoped=true&"
import script from "./userInfo_individualHome.vue?vue&type=script&lang=js&"
export * from "./userInfo_individualHome.vue?vue&type=script&lang=js&"
import style0 from "./userInfo_individualHome.vue?vue&type=style&index=0&id=e52c8264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52c8264",
  null
  
)

export default component.exports